import React from 'react';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import 'react-horizontal-scrolling-menu/dist/styles.css';
import LeftArrow from '../../ui/Arrows/LeftArrow';
import RightArrow from '../../ui/Arrows/RightArrow';
import ProjectCard from '../../ui/card/projectCard';
import projects from './constants/projects';


const getItems = () =>
  projects
    .map((item) => ({...item ,id: `${item.id}`, title: `${item.title}`}));

const ProjectsPage = React.forwardRef((props, ref) => {

  const [items, setItems] = React.useState(getItems);
  const [selected, setSelected] = React.useState([]);

  const isItemSelected = (id) => !!selected.find((el) => el === id);

  const handleClick =
    (id) =>
    ({ getItemById, scrollToItem }) => {
      const itemSelected = isItemSelected(id);

      setSelected((currentSelected) =>
        itemSelected
          ? currentSelected.filter((el) => el !== id)
          : currentSelected.concat(id),
      );
    };


  return (
    <div ref={ref} className='container-fluid  p-md-0 py-2  m-0 position-relative'>
     <h1 className='section-title-project ms-md-5 ms-1 text-break '>PROJECTS</h1>
     <h5 className='text-end pe-5 pt-3 text-secondary mt-5 mb-2 end-0'>Presto online</h5>
        <div  className="container text-center mb-5">
       
                <ScrollMenu>
                  {items.map(({ id, image, title, link }) => (
                    <ProjectCard
                      itemId={id} 
                      title={title}
                      link={link}
                      key={id}
                      image={image}
                      onClick={handleClick(id)}
                      selected={isItemSelected(id)}
                    />
                  ))}
                </ScrollMenu>

                <div className="d-flex justify-content-end mt-md-5 mt-3">
                  <LeftArrow/>
                  <RightArrow/>
                </div>

            </div>

    </div>

  );
});






export default ProjectsPage;